import { actionCreator } from '@ardoq/rxbeach';
import {
  APIAttachment,
  APIDocumentArchiveFolder,
  ArdoqId,
} from '@ardoq/api-types';

// Folder actions
export const fetchWorkspaceDocumentArchiveFolders = actionCreator<ArdoqId>(
  '[documentArchive/folders] FETCH_WORKSPACE'
);

export const setOrgDocumentArchiveFolders = actionCreator<
  APIDocumentArchiveFolder[]
>('[documentArchive/folders] SET_ORG_FOLDERS');

export const setWorkspaceDocumentArchiveFolders = actionCreator<
  APIDocumentArchiveFolder[]
>('[documentArchive/folders] SET_WORKSPACE_FOLDERS');

export const fetchWorkspaceDocumentArchiveAttachments = actionCreator<ArdoqId>(
  '[documentArchive/attachments] FETCH_WORKSPACE'
);

export const setOrgDocumentArchiveAttachments = actionCreator<APIAttachment[]>(
  '[documentArchive/attachments] SET_ORG_ATTACHMENTS'
);

export const setWorkspaceDocumentArchiveAttachments = actionCreator<
  APIAttachment[]
>('[documentArchive/attachments] SET_WORKSPACE_ATTACHMENTS');

export const resetDocumentArchiveAttachments = actionCreator<APIAttachment[]>(
  '[documentArchive/attachments] RESET_ATTACHMENTS'
);
